interface TopCardProps {
  bg: string;
  icon: string;
  color: string;
  count: number | undefined;
  title: string;
}

export default function ShiftTopCard({
  bg,
  color,
  count,
  icon,
  title,
}: TopCardProps) {
  return (
    <div className="flex gap-3 px-3 py-4 bg-white rounded-md border border-extra-light">
      <div
        className="h-[52px] w-[52px] rounded-full justify-center items-center inline-flex"
        style={{ backgroundColor: bg }}
      >
        <img src={icon} alt="" />
      </div>
      <div className="flex-1">
        <h4
          className="text-[22px] font-semibold leading-[33px]"
          style={{ color: color }}
        >
          {count}
        </h4>
        <span className="text-extra-gray text-sm font-medium leading-normal inline-block">
          {title}
        </span>
      </div>
    </div>
  );
}
